import { HardTokenIntegrationController } from '../../hard-token-integration/hard-token-integration.controller';
import { HardTokenAddController } from '../hard-token-add.controller';

export class Controller extends HardTokenAddController {

    /** @ngInject */
    constructor($state,HardTokenService,Alert) {
        super($state,HardTokenService,Alert);
    }

    $onInit() {
        super.$onInit();
        this.type = 'YUBIKey_USB_KEY';
        this.otpType = 'U2F';
        console.log(this);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/fido-add/fido-add.controller.js